export default __webpack_public_path__ + "static/awards-full-7dea770de560eb8532dee2de10eabf90.png";